import React from "react";
import randstad from "../assets/randstad.png";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <img className="mb-3 app-logo" src={randstad} alt="Scope logo" width="40" />
    <p>© Randstad 2020</p>
  </footer>
);

export default Footer;
